import React from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

const RoleLayout = ({ sidebar: Sidebar }) => {
  const bg = useColorModeValue('gray.50', 'gray.900');

  return (
    <Flex minH="100vh" bg={bg}>
      {Sidebar && <Sidebar />}
      
      <Box
        flex="1"
        ml={{ base: 0, lg: Sidebar ? "250px" : 0 }}
        transition="margin-left 0.3s"
      >
        <Outlet />
      </Box>
    </Flex>
  );
};

export default RoleLayout;
